// extracted by mini-css-extract-plugin
export var desktopImage = "FullScreenBanner-module--desktopImage--1d035";
export var mobileImage = "FullScreenBanner-module--mobileImage--176b5";
export var placeholder = "FullScreenBanner-module--placeholder--bbe6d";
export var wrapper = "FullScreenBanner-module--wrapper--300ed";